import React from 'react';
import PropTypes from 'prop-types';

import { Collapse as MUICollapse } from '@material-ui/core';

export const Collapse = props => <MUICollapse {...props} />;

Collapse.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  component: PropTypes.elementType,
  in: PropTypes.bool,
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto']), PropTypes.object])
};

export default Collapse;
